import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { CoreModule } from '@core/core.module';
import { environment } from '@environment';

registerLocaleData(localeFr, 'fr');

if (environment.production) {
  enableProdMode();
}

platformBrowser()
  .bootstrapModule(CoreModule)
  .catch((err) => {
    // eslint-disable-next-line no-console
    console.error(err);
  });
